import {cdnImage} from '@/util/cdnImage';
import React, {memo} from 'react';
import dynamic from 'next/dynamic';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'));

const NftTechnology = (props: any) => {
    const {heading, subheading} = props;
    return (
        <Box>
            <Box className="spectrum-header-wrapper margin">
                <Typography className="spectrum-heading">{heading}</Typography>
                <Box className="divder-wrapper">
                    <hr className="divider-line" />
                </Box>
                <Box className="sub-heading-box text-padding">
                    <Typography className="spectrum-sub-heading color-black">{subheading}</Typography>
                </Box>
            </Box>
            <Grid container className="top-spacing">
                <Grid item xs={12} sm={12} md={5} lg={5}>
                    <Grid container>
                        <Typography variant="h6" className="tech-work-heading">
                            We build on all major Blockchain platforms
                        </Typography>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                            <Box className="benefit-section-card">
                                <List subheader={<li />}>
                                    <ListItem key={`item-1`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage
                                                src={cdnImage('technologies/ethereum.svg')}
                                                alt="ethereum"
                                                width={17}
                                                height={27}
                                            />
                                        </Box>

                                        <ListItemText className="list-item" primary="Ethereum" />
                                    </ListItem>
                                    <ListItem key={`item-2`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/polygon.svg')} alt="polygon" width={24} height={21} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Polygon" />
                                    </ListItem>
                                    <ListItem key={`item-3`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage
                                                src={cdnImage('technologies/avalanche.svg')}
                                                alt="avalanche"
                                                width={24}
                                                height={25}
                                            />
                                        </Box>
                                        <ListItemText className="list-item" primary="Avalanche" />
                                    </ListItem>
                                    <ListItem key={`item-4`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage
                                                src={cdnImage('technologies/algorand.svg')}
                                                alt="algorand"
                                                width={24}
                                                height={25}
                                            />
                                        </Box>
                                        <ListItemText className="list-item" primary="Algorand" />
                                    </ListItem>
                                    <ListItem key={`item-5`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/solana.svg')} alt="solana" width={23} height={19} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Solana" />
                                    </ListItem>
                                </List>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                            <Box className="benefit-section-card">
                                <List subheader={<li />}>
                                    <ListItem key={`item-1`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/tezos.svg')} alt="tezos" width={18} height={24} />
                                        </Box>

                                        <ListItemText className="list-item" primary="Tezos" />
                                    </ListItem>
                                    <ListItem key={`item-2`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/tron.svg')} alt="tron" width={25} height={26} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Tron" />
                                    </ListItem>
                                    <ListItem key={`item-3`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage
                                                src={cdnImage('technologies/hyperledger.svg')}
                                                alt="hyperledger"
                                                width={26}
                                                height={26}
                                            />
                                        </Box>
                                        <ListItemText className="list-item" primary="Hyperledger Fabric" />
                                    </ListItem>
                                    <ListItem key={`item-4`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage
                                                src={cdnImage('technologies/binance smart-chain.svg')}
                                                alt="binance"
                                                width={28}
                                                height={28}
                                            />
                                        </Box>
                                        <ListItemText className="list-item" primary="Binance Smart Chain" />
                                    </ListItem>
                                </List>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={7} lg={7}>
                    <Typography variant="h6" className="tech-work-heading">
                        We use industry-leading technologies
                    </Typography>
                    <Grid container>
                        <Grid item xs={6} sm={4} md={4} lg={4}>
                            <Box className="benefit-section-card">
                                <List subheader={<li />}>
                                    <ListItem key={`item-1`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/Node.JS.svg')} alt="Node" width={24} height={28} />
                                        </Box>

                                        <ListItemText className="list-item" primary="Node JS" />
                                    </ListItem>
                                    <ListItem key={`item-2`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/Nest JS.svg')} alt="next js" width={28} height={28} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Next JS" />
                                    </ListItem>
                                    <ListItem key={`item-3`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/next.js.svg')} alt="nest js" width={24} height={24} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Nest Js" />
                                    </ListItem>
                                    <ListItem key={`item-4`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/React JS.svg')} alt="React" width={25} height={22} />
                                        </Box>
                                        <ListItemText className="list-item" primary="React JS" />
                                    </ListItem>
                                    <ListItem key={`item-5`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/Three JS.svg')} alt="three" width={23} height={22} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Three JS" />
                                    </ListItem>
                                </List>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={4} md={4} lg={4}>
                            <Box className="benefit-section-card">
                                <List subheader={<li />}>
                                    <ListItem key={`item-1`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/web3js.svg')} alt="web3js" width={24} height={23} />
                                        </Box>

                                        <ListItemText className="list-item" primary="Web3 JS" />
                                    </ListItem>
                                    <ListItem key={`item-2`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/python.svg')} alt="python" width={24} height={24} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Python" />
                                    </ListItem>
                                    <ListItem key={`item-3`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/kotlin.svg')} alt="kotlin" width={19} height={19} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Kotlin" />
                                    </ListItem>
                                    <ListItem key={`item-4`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/mongodb.svg')} alt="mongodb" width={12} height={28} />
                                        </Box>
                                        <ListItemText className="list-item" primary="MongoDb" />
                                    </ListItem>
                                    <ListItem key={`item-5`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage
                                                src={cdnImage('technologies/postgresql.svg')}
                                                alt="postgresql"
                                                width={22}
                                                height={22}
                                            />
                                        </Box>
                                        <ListItemText className="list-item" primary="Postgres" />
                                    </ListItem>
                                </List>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={4} md={4} lg={4}>
                            <Box className="benefit-section-card">
                                <List subheader={<li />}>
                                    <ListItem key={`item-1`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/aws.svg')} alt="aws" width={28} height={18} />
                                        </Box>

                                        <ListItemText className="list-item" primary="AWS" />
                                    </ListItem>
                                    <ListItem key={`item-2`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/azure.svg')} alt="azure" width={26} height={21} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Azure" />
                                    </ListItem>
                                    <ListItem key={`item-3`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/go.svg')} alt="go" width={17} height={23} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Go" />
                                    </ListItem>
                                    <ListItem key={`item-9`} className="tech-list">
                                        <Box className="flag-icon">
                                            <DisplayImage src={cdnImage('technologies/flutter.svg')} alt="flutter" width={19} height={24} />
                                        </Box>
                                        <ListItemText className="list-item" primary="Flutter" />
                                    </ListItem>
                                </List>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default memo(NftTechnology);
